import React from 'react';

const ROWS = 7;

const Bone = ({ w, h = 12, round = false }) => (
  <span className="ui-skel sdir-bone" style={{ width: w, height: h, borderRadius: round ? '50%' : undefined }} />
);

/**
 * What the Directory looks like while the first page loads: a card with the same columns as the
 * table that is coming (the ones this viewer is granted), so the page does not jump when the rows
 * land. It appears after 150ms, so a fast answer never flashes it.
 */
function DirectorySkeleton({ columns, label }) {
  const cells = [
    'student',
    columns.contact && 'contact',
    columns.learning && 'progress',
    columns.lesson && 'lesson',
    columns.presence && 'seen',
  ].filter(Boolean);
  const template = { gridTemplateColumns: `minmax(0, 1.3fr) repeat(${cells.length - 1}, minmax(0, 1fr))` };

  const cell = (kind) => {
    switch (kind) {
      case 'student':
        return (
          <div className="sdir-skel-person">
            <Bone w={40} h={40} round />
            <div className="sdir-skel-lines"><Bone w="70%" h={14} /><Bone w="55%" h={11} /></div>
          </div>
        );
      case 'progress':
        return <div className="sdir-skel-lines"><Bone w="60%" h={11} /><Bone w="100%" h={8} /></div>;
      default:
        return <div className="sdir-skel-lines"><Bone w="75%" h={13} /><Bone w="50%" h={11} /></div>;
    }
  };

  return (
    <div className="ui-table-card sdir-skel" role="status" aria-busy="true" aria-label={label}>
      <div className="sdir-skel-row sdir-skel-head" style={template} aria-hidden="true">
        {cells.map((kind) => <Bone key={kind} w={kind === 'student' ? 64 : 72} h={11} />)}
      </div>
      {Array.from({ length: ROWS }).map((_, i) => (
        <div key={i} className="sdir-skel-row" style={template} aria-hidden="true">
          {cells.map((kind) => <div key={kind}>{cell(kind)}</div>)}
        </div>
      ))}
      <span className="visually-hidden">{label}</span>
    </div>
  );
}

export default DirectorySkeleton;
